module.exports = __webpack_public_path__ + "img/dyehard.dcef0d61.png";